import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Tab from './Tab'

import './index.scss'

export default class Tabs extends PureComponent {
  static Tab = Tab

  static propTypes = {
    /** One or more "Tab" elements */
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node)
    ])
  }

  constructor(props) {
    super(props)
    const children = React.Children.toArray(props.children)
    const activeIndex = children.findIndex(({ props: { active } }) => active)
    this.state = { activeTabIndex: activeIndex === -1 ? 0 : activeIndex }
  }

  componentDidUpdate(prevProps, prevState) {
    const children = React.Children.toArray(this.props.children)
    if (
      this.state.activeTabIndex === -1 ||
      this.state.activeTabIndex > children.length - 1
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ activeTabIndex: children.length - 1 })
    }
  }

  setActiveTabIndex = (index, props) => {
    return this.setState({ activeTabIndex: index }, () => {
      if (this.props.onTabChange) {
        this.props.onTabChange(index, props)
      }
    })
  }

  get renderTabs() {
    const { activeTabIndex } = this.state
    return React.Children.map(this.props.children, ({ props }, index) => {
      return (
        <Tab
          {...props}
          selected={activeTabIndex === index}
          onClick={() => this.setActiveTabIndex(index, props)}
        />
      )
    })
  }

  render() {
    const { activeTabIndex } = this.state
    const { children } = this.props
    return (
      <div className='ublique-tabs-container'>
        <div className='ublique-tabs-tabs bx--tabs' role='navigation'>
          <ul role='tablist' className='bx--tabs__nav bx--tabs__nav--hidden'>
            {this.renderTabs}
          </ul>
        </div>
        <div className='ublique-tabs-content'>
          {React.Children.map(
            children,
            ({ props: { children: child } }, index) => {
              return (
                <div
                  key={index}
                  role='tabpanel'
                  hidden={index !== activeTabIndex}
                  className='bx--tab-content'
                >
                  {child}
                </div>
              )
            }
          )}
        </div>
      </div>
    )
  }
}
